
import { PlusCircleOutlined } from "@ant-design/icons";
import { Button, Flex, Radio } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../../../Layout";
import { addBusiness_V4 } from "../../../../api/business/businessApi";
import * as customerApi from '../../../../api/customer/customerApi';
import { addRelativeCustomer_V4 } from "../../../../api/relatives/relativesApi";
import BreadcrumbBlock from "../../../../components/BreadcrumbBlock/BreadcrumbBlock";
import ModalDeleteManager from "../../../../components/ModalDeleteManager";
import BusinessCollapseAddCustomer_V2 from "../../../../components/Relative/BusinessCollapseAddCustomer_V2";
import RelativeCollapseAddCustomer from "../../../../components/Relative/RelativeCollapseAddCustomer";
import useToast from '../../../../hook/useToast';
import { selectorInfoUser } from "../../../../store/slices/infoUserSlice";
import AddBusinessAddCustomer, { IRelativeBusinessADD_V2 } from "../../Modal/AddBusinessAddCustomer";
import AddRelativeAddCustomer, { IRelationshipADD_V2 } from "../../Modal/AddRelativeAddCustomer";
import CreateFavoriteCarModal from "../../Modal/CreateFavoriteCar";
import UpdateBusinessAddCustomer_V2 from "../../Modal/UpdateBusinessAddCustomer_V2";
import UpdateRelativeAddCustomer from "../../Modal/UpdateRelativeAddCustomer";
import FavoriteCarDrawer from "../Drawer/FavoriteCar";
import OwnedCarDrawer from "../Drawer/OwnedCar";
import PersonalInformation from "./Component/PersonalInformation";
import './style.scss';


const tabInfoCustomer = [
  { value: 'relative', label: 'Thông tin người liên hệ' },
  { value: 'business', label: 'Thông tin doanh nghiệp' },
]


const AddCustomer: React.FC = () => {

  const pushToast = useToast();
  const navigate = useNavigate()
  const { unitTemp } = useSelector(selectorInfoUser)

  useEffect(() => {

    return (() => {
      setShowAddRelativeModal(false)
      setIsModalRelativesUpdate(false)
      setIsModalRelativesDelete(false)
      setShowAddBusinessModal(false)
      setIsModalBusinessUpdate(false)
      setIsModalRelativesDelete(false)

      setIsFormSubmitted(false)

      setOpenIndex(undefined)
      setIDChoose(undefined)
      // setListRelative([])
      setInfoRelative(undefined)
      setInfoBusiness(undefined)
    })
  }, [])

  // ADD RELATIVE
  const [showAddRelativeModal, setShowAddRelativeModal] = useState(false)
  const [showAddBusinessModal, setShowAddBusinessModal] = useState(false)
  const [isModalRelativesUpdate, setIsModalRelativesUpdate] = useState(false)
  const [isModalRelativesDelete, setIsModalRelativesDelete] = useState(false)
  const [isModalBusinessUpdate, setIsModalBusinessUpdate] = useState(false)
  const [isModalBusinessDelete, setIsModalBusinessDelete] = useState(false)

  // BASIC INFORMATION SUBMIT
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)


  // CAR LIST
  const [showOwnedCarDrawer, setShowOwnedCarDrawer] = useState(false)
  const [showFavoriteCarDrawer, setShowFavoriteCarDrawer] = useState(false)
  const [showCreateFavoriteCarModal, setShowCreateFavoriteCarModal] = useState(false)

  // RELATIVES
  const [openIndex, setOpenIndex] = useState<number>()
  const [idChoose, setIDChoose] = useState<number>()
  const [selectedTabInfoCustomer, setSelectedTabInfoCustomer] = useState('relative')

  const [listRelative, setListRelative] = useState<IRelationshipADD_V2[]>([])
  const [listBusiness, setListBusiness] = useState<IRelativeBusinessADD_V2[]>([])
  const [infoRelative, setInfoRelative] = useState<IRelationshipADD_V2>()
  const [infoBusiness, setInfoBusiness] = useState<IRelativeBusinessADD_V2>()


  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? undefined : index)
  }


  //DS ng thân
  //infor
  const gInfoRelative = async (index: number) => {
    setOpenIndex(index)
    setInfoRelative(listRelative[index])
    setIsModalRelativesUpdate(true)
  }

  //thêm
  const handleAddListRelative = (infoRelative: IRelationshipADD_V2) => {
    console.log(infoRelative, 'add')
    setShowAddRelativeModal(false)
    setListRelative((prevList) => [...prevList, infoRelative]);
  }
  //update
  const handleUpdateListRelative = async (index: number, infoRelative: IRelationshipADD_V2) => {
    setIsModalRelativesUpdate(false)
    setListRelative((prevList) => {
      // Tạo bản sao của mảng hiện tại
      const newList = [...prevList];
      // Cập nhật phần tử tại vị trí index
      newList[index] = { ...newList[index], ...infoRelative };
      // Trả về mảng đã được cập nhật
      return newList;
    });
  }

  const openModalDelete = (id: number) => {
    setIDChoose(id)
    setIsModalRelativesDelete(true)
  }

  const onConfirmDelete = async () => {
    setListRelative((prevList) => {
      // Lọc bỏ phần tử tại index
      return prevList.filter((_, i) => i !== idChoose);
    });
    setIsModalRelativesDelete(false)
  }

  const closeModalDeleter = () => {
    setIDChoose(undefined)
    setIsModalRelativesDelete(false)
  }

  //DS doanh nghiệp
  //thêm
  const handleAddListBusiness = (infoBusiness: IRelativeBusinessADD_V2) => {
    setShowAddBusinessModal(false)
    setListBusiness((prevList) => [...prevList, infoBusiness]);
  }

  const gInfoBusiness = async (index: number) => {
    setOpenIndex(index)
    setInfoBusiness(listBusiness[index])
    setIsModalBusinessUpdate(true)
    // setShowAddBusinessModal(true)
  }

  const handleUpdateListBusiness = async (index: number, infoBusiness: IRelativeBusinessADD_V2) => {
    setIsModalBusinessUpdate(false)
    setListBusiness((prevList) => {
      // Tạo bản sao của mảng hiện tại
      const newList = [...prevList];
      // Cập nhật phần tử tại vị trí index
      newList[index] = { ...newList[index], ...infoBusiness };
      // Trả về mảng đã được cập nhật
      return newList;
    });
  }

  const openModalDeleteBusiness = (id: number) => {
    setIDChoose(id)
    setIsModalBusinessDelete(true)
  }

  const onConfirmDeleteBusiness = async () => {
    setListBusiness((prevList) => {
      // Lọc bỏ phần tử tại index
      return prevList.filter((_, i) => i !== idChoose);
    });
    setIsModalBusinessDelete(false)
  }

  const closeModalDeleterBusiness = () => {
    setIDChoose(undefined)
    setIsModalBusinessDelete(false)
  }

  const resultFormSubmitAddCustomer = async (
    iSsuccess: boolean, message?: string, data?: customerApi.ICustomerDetail_V3
  ) => {
    if (!iSsuccess) {
      pushToast(message, "error");
      return;
    }

    pushToast(message, "success");
    if (data) {
      await handleAddRelatives(data.businessCheck, data.id);
      await handleAddBusinesses(data.id,);

      navigate(-1)
    }


    pushToast("Hoàn tất thêm người liên hệ và doanh nghiệp", "success");
    // navigator(-1);
  };

  const handleAddRelatives = async (businessCheck: number, customerId: number) => {
    for (const relative of listRelative as IRelationshipADD_V2[]) {
      try {
        // Kiểm tra hợp lệ
        const {
          email, phone, userName, CCCD, gender, inforSelectedCodeCustomer, profession, relativeId
        } = relative;
        if (
          businessCheck == undefined || !userName || !phone || !customerId
        ) {
          throw new Error(
            `Dữ liệu không hợp lệ cho ${userName || "một người liên hệ"}`
          );
        }

        const result = await addRelativeCustomer_V4(
          businessCheck, userName, phone, undefined,
          undefined, undefined, CCCD, gender,
          undefined, undefined, profession, undefined,
          email, undefined, undefined, undefined,
          undefined, undefined, undefined, 1,
          customerId, relativeId, undefined, undefined,
          undefined, undefined, inforSelectedCodeCustomer?.id
        );

        if (!result?.status) {
          throw new Error(result?.message || "Lỗi không xác định trong quá trình cập nhật");
        }

        pushToast(`Cập nhật thành công: ${userName}`, "success");
      } catch (error: any) {
        pushToast(`Lỗi: ${error.message}`, "error");
      }
    }
  };

  const handleAddBusinesses = async (customerId: number) => {
    for (const business of listBusiness as IRelativeBusinessADD_V2[]) {
      try {
        const {
          email, inforSelectedCodeCustomer, phone, professionId, businessName, businessRelationshipId, unitTempId
        } = business;
        if (
          !customerId || !inforSelectedCodeCustomer.value || !businessName || !phone
        ) {
          throw new Error(
            `Dữ liệu không hợp lệ cho ${businessName || "một doanh nghiệp"}`
          );
        }

        const result = await addBusiness_V4(
          customerId, inforSelectedCodeCustomer.value, businessName, phone,
          professionId, email, businessRelationshipId, unitTempId
        )

        if (!result?.status) {
          throw new Error(result?.message || "Lỗi không xác định trong quá trình cập nhật");
        }

        pushToast(`Cập nhật thành công doanh nghiệp: ${businessName}`, "success");
      } catch (error: any) {
        pushToast(`Lỗi: ${error.message}`, "error");
      }
    }
  };


  useEffect(() => {
    if (!isModalRelativesUpdate)
      setInfoRelative(undefined)
  }, [isModalRelativesUpdate])

  useEffect(() => {
    if (!isModalBusinessUpdate)
      setInfoBusiness(undefined)
  }, [isModalBusinessUpdate])

  useEffect(() => {
    if (isFormSubmitted) {
      setTimeout(() => {
        setIsFormSubmitted(false)
      }, 2000);
    }
  }, [isFormSubmitted])

  return (
    <>
      <Layout contentClassName='customer-add-content'>
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: <Link to="/customer/list">Khách hàng</Link>, },
            { title: <Link to="/customer/list">Danh sách khách hàng</Link>, },
            { title: 'Thêm mới khách hàng', },
          ]}
          title='Thêm mới khách hàng'
          backLink='/customer/list'
          className="gutter-block-end"
        />

        <AddRelativeAddCustomer
          show={showAddRelativeModal}
          modalClose={() => setShowAddRelativeModal(false)}
          onSuccess={() => setShowAddRelativeModal(false)}
          handleAddListRelative={handleAddListRelative}
        />

        <UpdateRelativeAddCustomer
          show={isModalRelativesUpdate}
          index={openIndex}
          infoRelative={infoRelative}
          modalClose={() => setIsModalRelativesUpdate(false)}
          handleUpdateListRelative={handleUpdateListRelative}
        />
        <AddBusinessAddCustomer
          show={showAddBusinessModal}
          modalClose={() => setShowAddBusinessModal(false)}
          onSuccess={() => setShowAddBusinessModal(false)}
          handleAddListBusiness={handleAddListBusiness}
        />

        <UpdateBusinessAddCustomer_V2
          show={isModalBusinessUpdate}
          index={openIndex}
          infoBusiness={infoBusiness}
          modalClose={() => setIsModalBusinessUpdate(false)}
          handleUpdateListBusiness={handleUpdateListBusiness}
        />

        <ModalDeleteManager
          isOpen={isModalRelativesDelete}
          title="Bạn có chắc chắn xóa người liên hệ này"
          titleDelete="Xóa người liên hệ"
          content="Người liên hệ và dữ liệu liên quan sẽ bị xóa vĩnh viễn
      không thể khôi phục"
          onConfirm={onConfirmDelete}
          closeModal={closeModalDeleter}
        />

        <ModalDeleteManager
          isOpen={isModalBusinessDelete}
          title="Bạn có chắc chắn xóa doanh nghiệp này"
          titleDelete="Xóa doanh nghiệp"
          content="Doanh nghiệp và dữ liệu liên quan sẽ bị xóa vĩnh viễn
      không thể khôi phục"
          onConfirm={onConfirmDeleteBusiness}
          closeModal={closeModalDeleterBusiness}
        />

        <Flex vertical className="gap-24px">
          <Flex align="center" className="gap-12px">
            <p className="text-344054 text-sm fw-500 text-center font-medium">Thông tin cá nhân</p>
            <Button
              type="primary"
              className="rs-button rs-button--sm mis-auto"
              onClick={() => setIsFormSubmitted(true)}
            >Xác nhận</Button>
          </Flex>

          <div className="mw-1192">
            <PersonalInformation
              isFormSubmitted={isFormSubmitted}
              onSuccess={(formData) => {
                setIsFormSubmitted(false)
              }}
              setIsFormSubmitted={setIsFormSubmitted}
              resultFormSubmit={resultFormSubmitAddCustomer}
            />
          </div>

          <div className="mw-1192">
            <div className={`order-history-card`}>
              <div className="order-history-card__head mb-4">
                <Radio.Group
                  value={selectedTabInfoCustomer}
                  className='rs-radio-group'
                  onChange={(e) => setSelectedTabInfoCustomer(e.target.value)}
                >
                  {
                    tabInfoCustomer.map((item) => (
                      <Radio.Button
                        key={item.value}
                        value={item.value}
                        className='rs-radio'
                      >{item.label}</Radio.Button>
                    ))
                  }
                </Radio.Group>
                {
                  selectedTabInfoCustomer === 'relative' ?
                    <Button
                      icon={<PlusCircleOutlined />}
                      iconPosition='end'
                      className='rs-button rs-button--sm primary-outline'
                      onClick={() => setShowAddRelativeModal(true)}
                    >Thêm mới</Button>
                    :
                    <Button
                      icon={<PlusCircleOutlined />}
                      iconPosition='end'
                      className='rs-button rs-button--sm primary-outline'
                      onClick={() => setShowAddBusinessModal(true)}
                    >Thêm mới</Button>
                }
              </div>

              <Flex vertical className="gap-18px">
                {
                  selectedTabInfoCustomer === 'relative' ?
                    listRelative?.map((item, index) => (

                      <RelativeCollapseAddCustomer
                        key={index}
                        show={openIndex === index}
                        showControl

                        index={index}
                        infoRelative={item}

                        onToggle={() => handleToggle(index)}
                        handleOpenModalUpdate={gInfoRelative}
                        handleOpenModalDele={openModalDelete}
                      />
                    ))
                    :
                    listBusiness?.map((item, index) => (
                      <BusinessCollapseAddCustomer_V2
                        key={index}
                        show={openIndex === index}
                        showControl
                        index={index}
                        infoRelativeBusiness={item}

                        onToggle={() => handleToggle(index)}
                        handleOpenModalUpdate={gInfoBusiness}
                        handleOpenModalDele={openModalDeleteBusiness}
                      />
                    ))
                }
              </Flex>
            </div>
          </div>


        </Flex>
      </Layout>

      {/* OWNED CAR DRAWER */}
      <OwnedCarDrawer
        show={showOwnedCarDrawer}
        onClose={() => setShowOwnedCarDrawer(false)}
      />

      {/* FAVORITE CAR DRAWER */}
      <FavoriteCarDrawer
        show={showFavoriteCarDrawer}
        onClose={() => setShowFavoriteCarDrawer(false)}
      />

      {/* CREATE FAVORITE CAR MODAL */}
      <CreateFavoriteCarModal
        show={showCreateFavoriteCarModal}
        modalClose={() => setShowCreateFavoriteCarModal(false)}
      />

    </>
  )
}
export default AddCustomer
